import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PersonPortalState } from '@app/models/person-portal-state';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {

  public personPortalState: PersonPortalState;
  public accountName: String = "blah";

  constructor() { }

  ngOnInit(): void {
    this.initControls();
  }

  private initControls() { }

  /**
   * Called from the "Main" module when the selected account changes.
   */
  public refreshUI(): void {
    console.log('loaded');
    this.initUI();
  }

  public initUI(): void {
    this.personPortalState = LocalStorageUtilities.getPersonPortalState();
    this.accountName = this.personPortalState.mxna.accountName;
    console.log(this.accountName);
  }


}
